import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/RubinLogo250.png'


const _hoisted_1 = { id: "first-splash-row" }
const _hoisted_2 = {
  id: "splash-screen-text",
  class: "mb-2"
}
const _hoisted_3 = { class: "highlight" }
const _hoisted_4 = {
  href: "http://rubinobservatory.org/",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_5 = { id: "splash-screen-acknowledgements" }
const _hoisted_6 = { id: "splash-screen-logos" }

import { computed } from 'vue';
import { FocusTrap } from "focus-trap-vue";

export interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cssVars?: any;
  title: string;
  color?: string,
  highlightColor?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SplashScreen',
  props: /*@__PURE__*/_mergeModels({
    cssVars: { default: () => ({}) },
    title: {},
    color: {},
    highlightColor: {}
  }, {
    "modelValue": { default: true },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(['close'], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;

const cssVars = computed(() => {
  return {
    ...props.cssVars,
    ...{'--accent-color': props.color == null ? props.cssVars['--accent-color'] : props.color},
    ...{'--accent-color2': props.highlightColor == null ? props.cssVars['--accent-color2'] : props.highlightColor}
  };
});

const emits = __emit;

const showSplashScreen = _useModel(__props, "modelValue");
const splash = new URLSearchParams(window.location.search).get("splash")?.toLowerCase() !== "false";
if (!splash) {
  showSplashScreen.value = false;
}


function closeSplashScreen() {
  showSplashScreen.value = false;
  emits('close');
}



return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_credit_logos = _resolveComponent("credit-logos")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_component_v_overlay, {
    "model-value": showSplashScreen.value,
    absolute: "",
    opacity: "0.6",
    style: _normalizeStyle(cssVars.value),
    id: "splash-overlay"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(FocusTrap), null, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            id: "splash-screen",
            style: _normalizeStyle(cssVars.value)
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_font_awesome_icon, {
                id: "close-splash-button",
                onClick: closeSplashScreen,
                onKeyup: _withKeys(closeSplashScreen, ["enter"]),
                icon: "xmark",
                tabindex: "0"
              }),
              _createElementVNode("div", _hoisted_2, [
                _cache[0] || (_cache[0] = _createElementVNode("p", null, "See the", -1)),
                _createElementVNode("p", _hoisted_3, [
                  _createElementVNode("a", _hoisted_4, _toDisplayString(__props.title), 1)
                ]),
                _cache[1] || (_cache[1] = _createTextVNode(" Images! ", -1))
              ])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_v_btn, {
                class: "splash-get-started",
                onClick: closeSplashScreen,
                onKeyup: _withKeys(closeSplashScreen, ["enter"]),
                color: "secondary",
                density: _ctx.$vuetify.display.xs ? 'compact' : 'default',
                size: _ctx.$vuetify.display.width < 250 ? 'large' : 'x-large',
                variant: "elevated",
                rounded: "lg"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" Get Started ", -1)
                ]))]),
                _: 1
              }, 8, ["density", "size"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_credit_logos, {
                  id: "splash-screen-credit-logos",
                  "logo-size": "5vmin",
                  "default-logos": ['cosmicds', 'wwt'],
                  "extra-logos": [
              {
                alt: 'INTUITIVE Planetarium at the U.S. Space & Rocket Center',
                src: './SpaceRocketCenterIntuitivePlanetarium-Logo-small.png',
                href: 'https://www.rocketcenter.com/INTUITIVEPlanetarium',
                name: 'INTUITIVE'
              },
            ]
                }),
                _cache[3] || (_cache[3] = _createElementVNode("a", {
                  href: "https://rubinobservatory.org/",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, [
                  _createElementVNode("img", {
                    id: "rubin-large-logo",
                    alt: "Rubin Observatory Logo",
                    src: _imports_0
                  })
                ], -1))
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("span", null, [
                _createTextVNode(" Brought to you by "),
                _createElementVNode("a", {
                  href: "https://www.rocketcenter.com/INTUITIVEPlanetarium",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, [
                  _createElementVNode("em", null, "INTUITIVE"),
                  _createTextVNode("® Planetarium at the U.S. Space & Rocket Center")
                ]),
                _createTextVNode(", "),
                _createElementVNode("a", {
                  href: "https://www.cosmicds.cfa.harvard.edu/",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "Cosmic Data Stories"),
                _createTextVNode(" and "),
                _createElementVNode("a", {
                  href: "https://www.worldwidetelescope.org/home/",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "WorldWide Telescope"),
                _createTextVNode(" using the \"first look\" images from "),
                _createElementVNode("a", {
                  href: "https://rubinobservatory.org/",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "Rubin Observatory"),
                _createTextVNode(". ")
              ], -1))
            ])
          ], 4)), [
            [_directive_click_outside, closeSplashScreen]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value", "style"]))
}
}

})